import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './permissions.loaders';
import { converters } from './permissions.converters';
import { PermissionRolesFilters } from './permissions.types';

export const permissionsKeys = queryKeyFactory('permissions');

export const useRoles = (
  filters: Partial<PermissionRolesFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: permissionsKeys.list('roles', filters),
    queryFn: () => loaders.getRoles({ filters }),
    select: converters.getRoles,
    ...options,
  });
};

export const usePermissions = (
  _filters: Partial<{}> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: permissionsKeys.list('permissions'),
    queryFn: () => loaders.getPermissions(),
    select: converters.getPermissions,
    ...options,
  });
};
